import { render, staticRenderFns } from "./CrearCapacitacion.vue?vue&type=template&id=e7c6f680"
import script from "./CrearCapacitacion.vue?vue&type=script&lang=js"
export * from "./CrearCapacitacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports